import React, { useRef } from "react";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../components/FormValidation";
import useFormValidation from "../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../utils/helpers/formValidation";
import AkasSelect from "../../../components/AkasSelect";

const validationSchema = {
  type: [rule.required("Flag wajib dipilih."), rule.oneOf(["product", "material"], "Flag hanya boleh Produk atau Material.")],
  category_id: rule.required("Kategori wajib dipilih."),
  value: [rule.required("Kode tipe wajib diisi."), rule.maxLength(120)],
  label: [rule.required("Label tipe wajib diisi."), rule.maxLength(120)],
  description: rule.maxLength(255),
};

const FormCategoryType = (props) => {
  const {
    isEdit,
    closeModal,
    formState,
    setFormState,
    categories,
    isLoading,
    handleAdd,
    handleUpdate,
    allowedTypes = ["product", "material"],
  } = props;
  const formRef = useRef(null);
  const validation = useFormValidation({ values: formState, schema: validationSchema, formId: "category-type", focusRoot: formRef });

  const updateField = (field, value) => {
    setFormState((previous) => ({
      ...previous,
      [field]: value,
      ...(field === "type" ? { category_id: "" } : {}),
    }));
  };

  const filteredCategories = categories.filter(
    (category) => category.type === formState.type && allowedTypes.includes(category.type),
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validation.validateAll()) return;
    const success = isEdit ? await handleUpdate() : await handleAdd();

    if (success !== false) {
      document.querySelector("#modal-form-category-type .btn-close")?.click();
    }
  };

  return (
    <div
      className="modal modal-blur fade"
      id="modal-form-category-type"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <form ref={formRef} className="modal-content" onSubmit={handleSubmit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">Master Tipe {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Flag<RequiredMark /></label>
                  <AkasSelect
                    {...validation.fieldProps("type")}
                    data-validation-field="type"
                    className={validation.inputClass("type", "form-select")}
                    value={formState.type}
                    required
                    onChange={(event) => updateField("type", event.target.value)}>
                    {allowedTypes.includes("product") ? <option value="product">Produk</option> : null}
                    {allowedTypes.includes("material") ? <option value="material">Material</option> : null}
                  </AkasSelect>
                  <FieldFeedback formId="category-type" name="type" error={validation.errors.type} hint="Tentukan apakah tipe dipakai oleh produk atau material." />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Kategori<RequiredMark /></label>
                  <AkasSelect
                    {...validation.fieldProps("category_id")}
                    data-validation-field="category_id"
                    className={validation.inputClass("category_id", "form-select")}
                    value={formState.category_id}
                    required
                    onChange={(event) => updateField("category_id", event.target.value)}>
                    <option value="">-- Pilih Kategori --</option>
                    {filteredCategories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.label}
                      </option>
                    ))}
                  </AkasSelect>
                  <FieldFeedback formId="category-type" name="category_id" error={validation.errors.category_id} hint="Tipe hanya berlaku pada kategori yang dipilih." />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Kode Tipe<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("value")}
                    type="text"
                    className={validation.inputClass("value")}
                    placeholder="contoh: Arabica"
                    value={formState.value}
                    maxLength={120}
                    required
                    onChange={(event) => updateField("value", event.target.value)}
                  />
                  <FieldFeedback formId="category-type" name="value" error={validation.errors.value} hint="Maksimal 120 karakter; kode ini disimpan pada data produk/material." />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Label<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("label")}
                    type="text"
                    className={validation.inputClass("label")}
                    placeholder="contoh: Arabica"
                    value={formState.label}
                    maxLength={120}
                    required
                    onChange={(event) => updateField("label", event.target.value)}
                  />
                  <FieldFeedback formId="category-type" name="label" error={validation.errors.label} hint="Nama tipe yang tampil kepada pengguna." />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Deskripsi<RequiredMark optional /></label>
                  <textarea
                    {...validation.fieldProps("description")}
                    className={validation.inputClass("description")}
                    rows="3"
                    placeholder="keterangan tipe"
                    value={formState.description}
                    maxLength={255}
                    onChange={(event) => updateField("description", event.target.value)}></textarea>
                  <FieldFeedback formId="category-type" name="description" error={validation.errors.description} hint="Maksimal 255 karakter." />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              Cancel
            </button>
            {isEdit ? (
              <button type="submit" className="btn btn-primary btn-5 ms-auto" disabled={isLoading}>
                Edit Data
              </button>
            ) : (
              <button type="submit" className="btn btn-primary btn-5 ms-auto" disabled={isLoading}>
                Tambah Data
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormCategoryType;
